@if (this.data) {
  <div class="card-list p-3">
    @for (item of data; track item) {
      <div class="card-col">
        <div class="card data-card h-100">
          <div class="card-body">
            <div class="card-left pe-2">
              @if (
                item['isEmployee'] && (this.currentAvatar$ | async); as avatar
                ) {
                <img
                src="{{ avatar.url }}?name={{ item['contactName'] }}&bgColor={{
                  avatar.bgColor
                }}&color=FFFFFF"
                  class="card-img"
                  />
                }
                @if (!item['isEmployee'] && item['isCompany']) {
                  <img
                    class="card-img"
                    src="../../../../assets/images/avatar_company.svg"
                    />
                }
                @if (!item['isEmployee'] && !item['isCompany']) {
                  <img
                    class="card-img"
                    src="../../../../assets/images/user.svg"
                    />
                }
              </div>
              <div class="card-content">
                @if (item['name']) {
                  <h5 class="card-title">
                    {{ item["name"] }}
                  </h5>
                }
                <!--            <h5 class="card-title" *ngIf="!item['name']"> {{ item['id'] }} </h5>-->
                @if (item['fullCity']) {
                  <span
                    class="card-subtitle text-muted mb-1"
                    >
                    <i class="mdi mdi-map-marker me-1"></i>
                    {{ item["fullCity"] }}
                  </span>
                }
                @if (item['email']) {
                  <span class="card-subtitle text-muted mb-1">
                    <i class="mdi mdi-email me-1"></i>
                    {{ item["email"] }}
                  </span>
                }
                @if (item['categoryLoc']) {
                  <div>
                    <app-badge
                      [message]="item['categoryLoc']"
                      [color]="item['categoryColor']"
                    ></app-badge>
                  </div>
                }
                <!--            <span class="card-subtitle text-muted mb-1" *ngIf="item['contactPhoneNumber']">-->
                <!--              <i class="mdi mdi-phone me-1"></i>-->
                <!--              <app-phone-number [phoneNumber]="item['contactPhoneNumber']" />-->
              <!--                </span>-->
            </div>
          </div>
          <!--        <div class="card-ur-corner-wrapper">-->
          <!--          <div class="dropdown card-menu" *ngIf="view.kanbanView.states.length > 0">-->
          <!--            <button class="btn dropdown-toggle btn-outline-light show" type="button" id="dropdownMenuButton"-->
          <!--                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
          <!--              <i class="mdi mdi-dots-vertical"></i>-->
        <!--            </button>-->
        <!--            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="">-->
        <!--              <a class="dropdown-item" href="#" *ngFor="let state of view.kanbanView.states">{{ state }}</a>-->
      <!--            </div>-->
    <!--          </div>-->
  <!--        </div>-->
  <a (click)="onCardClick(item['uniqueId'])" class="stretched-link"></a>
</div>
</div>
}
</div>
}
